import { omit } from 'lodash';

export default function ensureInputHash(input, additionalKeys = []) {
  const removableKey = ['__typename', 'errors', 'gid', ...additionalKeys];

  let ensuredInput = {};

  const ensureArrayHash = (a) => {
    const ensuredArray = [];
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < a.length; index++) {
      const value = a[index];
      if (!Array.isArray(value) && typeof value === 'object') {
        ensuredArray[index] = ensureInputHash(value);
      } else {
        ensuredArray[index] = value;
      }
    }
    return ensuredArray;
  };

  const ensureHash = (hash) => {
    if (Array.isArray(hash) && hash.length > 0) {
      ensuredInput = ensureArrayHash(hash);
    } else if (!Array.isArray(hash) && typeof hash === 'object') {
      Object.keys(hash).forEach((key) => {
        if (hash[key] && typeof hash[key] === 'object' && !(hash[key] instanceof File)) {
          ensuredInput[key] = ensureInputHash(hash[key]);
        } else {
          ensuredInput[key] = hash[key];
        }
      });
      ensuredInput = omit(ensuredInput, removableKey);
    } else {
      ensuredInput = input;
    }
  };

  ensureHash(input);

  return ensuredInput;
}
